module.exports = __webpack_public_path__ + "static/media/Mush_Mozza-mb-en.6a614835.jpg";